export default __webpack_public_path__ + "static/media/impact.902c9f94.png";